export default {"src":"/_next/static/media/Fade.1876a8e3.svg","height":16,"width":16};